import React from "react";
import { useStore } from "../store";
import Section from "../components/section/section";
import HexagonButton from "../components/hexagon-button/hexagon-button";
import Hexagon1 from "../components/hexagon-1";
import Hexagon2 from "../components/hexagon-2";

export default function EndFrame60() {
  const { section, setSection, showEndFrame } = useStore();
  const watchedSections = React.useMemo(() => {
    return (
      JSON.parse(window.localStorage.getItem(`kasperskey.watchedSections`)) ??
      []
    );
  }, [section]);

  if (section !== 6.0 || !showEndFrame) return null;

  return (
    <Section name="6-0">
      <HexagonButton onClick={() => setSection(6.1)}>
        <div>
          Race back to the
          <br /> (home) office.
          <br /> Again
        </div>
        <Hexagon1 />
      </HexagonButton>
      <HexagonButton onClick={() => setSection(6.2)}>
        <div>
          Finish the day <br />
          in a new setting...
        </div>
        <Hexagon2 />
      </HexagonButton>
    </Section>
  );
}
